import { render, staticRenderFns } from "./ReservationAmount.vue?vue&type=template&id=01576aa4&"
import script from "./ReservationAmount.vue?vue&type=script&lang=js&"
export * from "./ReservationAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports